@use '@design/design-tokens/typography/typography' as *;
@use '@design/design-tokens/border-radius/border-radius' as *;
@use '@design/design-tokens/breakpoints/breakpoints' as *;

.historyPillWrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0;
  position: relative;
}

.labelWrapper {
  @include border-radius-r2;
  display: flex;
  align-items: center;
  width: 100%;
  max-width: 265px;
  height: 32px;
  margin-top: 2px;
  margin-left: 10px;
  background-color: unset;

  > svg {
    visibility: hidden;
  }

  &:hover,
  &:has([data-state='open']) {
    cursor: pointer;
    background-color: var(--surface-hover);

    @include respond-to('mobile') {
      background-color: unset;
    }

    > svg {
      visibility: visible;
    }
  }

  &.isActive {
    background-color: var(--surface-active);

    > svg {
      visibility: visible;
    }
  }
}

.label {
  display: flex;
  align-items: center;
  gap: 6px;
  @include typography-v2-body-sm;
  margin-bottom: 2px;
  flex: 1;
  min-width: 0;
  white-space: nowrap;

  span {
    flex: 1;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.labelRootDepth {
  margin-left: 8px;
}

.tooltipLabel {
  width: 290px;
  @include typography-v2-body-sm;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
  overflow: hidden;
  text-overflow: ellipsis;
  color: var(--text-soft);
}

.tooltipTitle {
  color: var(--text-soft);
}

.styledDropdownMenu {
  min-width: 100px;

  [data-dropdown-menu-item][data-key='delete'] {
    svg {
      fill: var(--text-critical);
    }

    span {
      color: var(--text-critical);
    }
  }
}

.stroke {
  margin-top: -10px;
  margin-right: 8px;
  margin-left: 10px;
}

.verticalLine {
  width: 2px;
  height: 10px;
  background-color: var(--border-default);
}

.horizontalLine {
  width: 10px;
  height: 2px;
  background-color: var(--border-default);
}

.bookmarkIcon {
  transform: rotate(-90deg);
  position: absolute;
  left: -10px;

  @include respond-to('max-sm') {
    left: -16px;
  }
}
